 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"404":"404","NewPresenterSession~PresenterSessionEdit~ViewerSession~ViewerSessionPaused~ViewerSessionWaitingRoom":"NewPresenterSession~PresenterSessionEdit~ViewerSession~ViewerSessionPaused~ViewerSessionWaitingRoom","NewPresenterSession":"NewPresenterSession","PresenterSessionEdit":"PresenterSessionEdit","ViewerSession":"ViewerSession","ViewerSessionPaused":"ViewerSessionPaused","ViewerSessionWaitingRoom":"ViewerSessionWaitingRoom","PastSessions~PresenterHome":"PastSessions~PresenterHome","PastSessions":"PastSessions","PresenterHome":"PresenterHome","PresenterPreferences":"PresenterPreferences","PresenterPreferencesEmail":"PresenterPreferencesEmail","PresenterProfile":"PresenterProfile","PresenterRouterView":"PresenterRouterView","PresenterSession":"PresenterSession","PresenterSessionEditPoll~PresenterSessionNewPoll~PresenterSessionPolls~PresenterSessionQuestion":"PresenterSessionEditPoll~PresenterSessionNewPoll~PresenterSessionPolls~PresenterSessionQuestion","PresenterSessionEditPoll":"PresenterSessionEditPoll","PresenterSessionNewPoll":"PresenterSessionNewPoll","PresenterSessionQuestion":"PresenterSessionQuestion","PresenterSessionPollsSettings":"PresenterSessionPollsSettings","PresenterSessionPolls~PresenterSessionReport~PresenterSessionStats~ViewerSessionPolls":"PresenterSessionPolls~PresenterSessionReport~PresenterSessionStats~ViewerSessionPolls","PresenterSessionPolls":"PresenterSessionPolls","PresenterSessionReport~PresenterSessionStats~ViewerSessionReactions~ViewerSessionTV":"PresenterSessionReport~PresenterSessionStats~ViewerSessionReactions~ViewerSessionTV","PresenterSessionReport~PresenterSessionStats~ViewerSessionTV":"PresenterSessionReport~PresenterSessionStats~ViewerSessionTV","PresenterSessionReport":"PresenterSessionReport","PresenterSessionStats":"PresenterSessionStats","PresenterSessionQuestionSettings":"PresenterSessionQuestionSettings","ViewerSessionTV":"ViewerSessionTV","PresenterSessionWordclouds":"PresenterSessionWordclouds","PresenterSignin":"PresenterSignin","PresenterSignup":"PresenterSignup","ViewerRouterView":"ViewerRouterView","ViewerSessionEnded":"ViewerSessionEnded","ViewerSessionInfo~ViewerSessionNewQuestion~ViewerSessionPolls~ViewerSessionQuestion~ViewerSessionRea~69a7438f":"ViewerSessionInfo~ViewerSessionNewQuestion~ViewerSessionPolls~ViewerSessionQuestion~ViewerSessionRea~69a7438f","ViewerSessionPolls":"ViewerSessionPolls","ViewerSessionReactions":"ViewerSessionReactions","ViewerSessionInfo":"ViewerSessionInfo","ViewerSessionNewQuestion":"ViewerSessionNewQuestion","ViewerSessionQuestion":"ViewerSessionQuestion","ViewerSessionReview":"ViewerSessionReview","ViewerSessionWordcloud":"ViewerSessionWordcloud","ViewerSessionModerator":"ViewerSessionModerator","ViewerSessionReviewSuccess":"ViewerSessionReviewSuccess"}[chunkId]||chunkId) + "." + {"404":"b94d5362","NewPresenterSession~PresenterSessionEdit~ViewerSession~ViewerSessionPaused~ViewerSessionWaitingRoom":"11a79729","NewPresenterSession":"54cc7374","PresenterSessionEdit":"e0290468","ViewerSession":"2f9dd97f","ViewerSessionPaused":"23210243","ViewerSessionWaitingRoom":"54742ab5","PastSessions~PresenterHome":"0900d02f","PastSessions":"5ff3f061","PresenterHome":"4fcee0c4","PresenterPreferences":"ba1a16ff","PresenterPreferencesEmail":"8eb28606","PresenterProfile":"972200e7","PresenterRouterView":"adf1d9f5","PresenterSession":"e1973763","PresenterSessionEditPoll~PresenterSessionNewPoll~PresenterSessionPolls~PresenterSessionQuestion":"f6dbcc45","PresenterSessionEditPoll":"9feb7b0a","PresenterSessionNewPoll":"e9161657","PresenterSessionQuestion":"bc303545","PresenterSessionPollsSettings":"e5b0eb8c","PresenterSessionPolls~PresenterSessionReport~PresenterSessionStats~ViewerSessionPolls":"1fba5223","PresenterSessionPolls":"ab9b633d","PresenterSessionReport~PresenterSessionStats~ViewerSessionReactions~ViewerSessionTV":"31b512c6","PresenterSessionReport~PresenterSessionStats~ViewerSessionTV":"32130438","PresenterSessionReport":"3d6d9d83","PresenterSessionStats":"8b3f927c","PresenterSessionQuestionSettings":"d601a402","ViewerSessionTV":"1ad32f2b","PresenterSessionWordclouds":"8bf6d9db","PresenterSignin":"1e92ddee","PresenterSignup":"e0a6f7ed","ViewerRouterView":"e5822c1d","ViewerSessionEnded":"d8db4b87","ViewerSessionInfo~ViewerSessionNewQuestion~ViewerSessionPolls~ViewerSessionQuestion~ViewerSessionRea~69a7438f":"042638b7","ViewerSessionPolls":"4cdc7eb2","ViewerSessionReactions":"ee617d74","ViewerSessionInfo":"7978348d","ViewerSessionNewQuestion":"9ac0bf08","ViewerSessionQuestion":"60696193","ViewerSessionReview":"f83cdc30","ViewerSessionWordcloud":"5b538143","ViewerSessionModerator":"025679e3","ViewerSessionReviewSuccess":"a35be5c5"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"NewPresenterSession~PresenterSessionEdit~ViewerSession~ViewerSessionPaused~ViewerSessionWaitingRoom":1,"NewPresenterSession":1,"PresenterSessionEdit":1,"ViewerSessionReactions":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"404":"404","NewPresenterSession~PresenterSessionEdit~ViewerSession~ViewerSessionPaused~ViewerSessionWaitingRoom":"NewPresenterSession~PresenterSessionEdit~ViewerSession~ViewerSessionPaused~ViewerSessionWaitingRoom","NewPresenterSession":"NewPresenterSession","PresenterSessionEdit":"PresenterSessionEdit","ViewerSession":"ViewerSession","ViewerSessionPaused":"ViewerSessionPaused","ViewerSessionWaitingRoom":"ViewerSessionWaitingRoom","PastSessions~PresenterHome":"PastSessions~PresenterHome","PastSessions":"PastSessions","PresenterHome":"PresenterHome","PresenterPreferences":"PresenterPreferences","PresenterPreferencesEmail":"PresenterPreferencesEmail","PresenterProfile":"PresenterProfile","PresenterRouterView":"PresenterRouterView","PresenterSession":"PresenterSession","PresenterSessionEditPoll~PresenterSessionNewPoll~PresenterSessionPolls~PresenterSessionQuestion":"PresenterSessionEditPoll~PresenterSessionNewPoll~PresenterSessionPolls~PresenterSessionQuestion","PresenterSessionEditPoll":"PresenterSessionEditPoll","PresenterSessionNewPoll":"PresenterSessionNewPoll","PresenterSessionQuestion":"PresenterSessionQuestion","PresenterSessionPollsSettings":"PresenterSessionPollsSettings","PresenterSessionPolls~PresenterSessionReport~PresenterSessionStats~ViewerSessionPolls":"PresenterSessionPolls~PresenterSessionReport~PresenterSessionStats~ViewerSessionPolls","PresenterSessionPolls":"PresenterSessionPolls","PresenterSessionReport~PresenterSessionStats~ViewerSessionReactions~ViewerSessionTV":"PresenterSessionReport~PresenterSessionStats~ViewerSessionReactions~ViewerSessionTV","PresenterSessionReport~PresenterSessionStats~ViewerSessionTV":"PresenterSessionReport~PresenterSessionStats~ViewerSessionTV","PresenterSessionReport":"PresenterSessionReport","PresenterSessionStats":"PresenterSessionStats","PresenterSessionQuestionSettings":"PresenterSessionQuestionSettings","ViewerSessionTV":"ViewerSessionTV","PresenterSessionWordclouds":"PresenterSessionWordclouds","PresenterSignin":"PresenterSignin","PresenterSignup":"PresenterSignup","ViewerRouterView":"ViewerRouterView","ViewerSessionEnded":"ViewerSessionEnded","ViewerSessionInfo~ViewerSessionNewQuestion~ViewerSessionPolls~ViewerSessionQuestion~ViewerSessionRea~69a7438f":"ViewerSessionInfo~ViewerSessionNewQuestion~ViewerSessionPolls~ViewerSessionQuestion~ViewerSessionRea~69a7438f","ViewerSessionPolls":"ViewerSessionPolls","ViewerSessionReactions":"ViewerSessionReactions","ViewerSessionInfo":"ViewerSessionInfo","ViewerSessionNewQuestion":"ViewerSessionNewQuestion","ViewerSessionQuestion":"ViewerSessionQuestion","ViewerSessionReview":"ViewerSessionReview","ViewerSessionWordcloud":"ViewerSessionWordcloud","ViewerSessionModerator":"ViewerSessionModerator","ViewerSessionReviewSuccess":"ViewerSessionReviewSuccess"}[chunkId]||chunkId) + "." + {"404":"31d6cfe0","NewPresenterSession~PresenterSessionEdit~ViewerSession~ViewerSessionPaused~ViewerSessionWaitingRoom":"bbf0f9a9","NewPresenterSession":"d0a74f05","PresenterSessionEdit":"ae7f9249","ViewerSession":"31d6cfe0","ViewerSessionPaused":"31d6cfe0","ViewerSessionWaitingRoom":"31d6cfe0","PastSessions~PresenterHome":"31d6cfe0","PastSessions":"31d6cfe0","PresenterHome":"31d6cfe0","PresenterPreferences":"31d6cfe0","PresenterPreferencesEmail":"31d6cfe0","PresenterProfile":"31d6cfe0","PresenterRouterView":"31d6cfe0","PresenterSession":"31d6cfe0","PresenterSessionEditPoll~PresenterSessionNewPoll~PresenterSessionPolls~PresenterSessionQuestion":"31d6cfe0","PresenterSessionEditPoll":"31d6cfe0","PresenterSessionNewPoll":"31d6cfe0","PresenterSessionQuestion":"31d6cfe0","PresenterSessionPollsSettings":"31d6cfe0","PresenterSessionPolls~PresenterSessionReport~PresenterSessionStats~ViewerSessionPolls":"31d6cfe0","PresenterSessionPolls":"31d6cfe0","PresenterSessionReport~PresenterSessionStats~ViewerSessionReactions~ViewerSessionTV":"31d6cfe0","PresenterSessionReport~PresenterSessionStats~ViewerSessionTV":"31d6cfe0","PresenterSessionReport":"31d6cfe0","PresenterSessionStats":"31d6cfe0","PresenterSessionQuestionSettings":"31d6cfe0","ViewerSessionTV":"31d6cfe0","PresenterSessionWordclouds":"31d6cfe0","PresenterSignin":"31d6cfe0","PresenterSignup":"31d6cfe0","ViewerRouterView":"31d6cfe0","ViewerSessionEnded":"31d6cfe0","ViewerSessionInfo~ViewerSessionNewQuestion~ViewerSessionPolls~ViewerSessionQuestion~ViewerSessionRea~69a7438f":"31d6cfe0","ViewerSessionPolls":"31d6cfe0","ViewerSessionReactions":"45478f77","ViewerSessionInfo":"31d6cfe0","ViewerSessionNewQuestion":"31d6cfe0","ViewerSessionQuestion":"31d6cfe0","ViewerSessionReview":"31d6cfe0","ViewerSessionWordcloud":"31d6cfe0","ViewerSessionModerator":"31d6cfe0","ViewerSessionReviewSuccess":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
